import { Grid, Stack, Typography, useTheme } from "@mui/material";

const CaseStudyOverview = ({
    title, 
    data,
    footer=<></>,
    leftPanelMdSize=6,
    ...sx
}) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                direction={{xs: 'column', md: 'row'}}
                justifyContent={{xs: 'start', md: 'space-between'}}
                alignItems='start'
                container
                width='100%'
                spacing={{xs: 1, md: 5}}
                {...sx}
            >
                <Grid size={{xs: 12, md: leftPanelMdSize}}>
                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='start'
                        spacing={{xs: 1, md: 2}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 16, lg: 24}}
                            textAlign='left'
                            color={theme.palette.text.primary}
                            lineHeight={1.5}
                        >
                            {title}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={2}
                            color={theme.palette.text.primary}
                        >
                            {data.overview}
                        </Typography>
                    </Stack>
                </Grid>

                <Grid size={{xs: 12, md: 12-leftPanelMdSize}}>
                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='start'
                    >
                        {
                            data.list.map((item, index) => {
                                return <Stack
                                    key={index}
                                    direction='row'
                                    justifyContent='start'
                                    alignItems='start'
                                    py={0.5}
                                >
                                    <Typography
                                        fontWeight={600}
                                        fontSize={{xs: 12, md: 12, lg: 14}}
                                        textAlign="left"
                                        lineHeight={2}
                                        color={theme.palette.text.secondary}
                                        px={1}
                                    >
                                        {index + 1}.
                                    </Typography>

                                    <Typography
                                        fontWeight={500}
                                        fontSize={{xs: 12, md: 12, lg: 14}}
                                        textAlign="justify"
                                        lineHeight={2}
                                        color={theme.palette.text.primary}
                                    >
                                        {item}
                                    </Typography>
                                </Stack>
                            })
                        }

                        {footer}
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
}

export default CaseStudyOverview;